import {Component, Input, OnInit} from '@angular/core';
import {Information} from "../information";

@Component({
  selector: 'app-information-naw',
  templateUrl: './information-naw.component.html',
  styleUrls: ['./information-naw.component.css']
})
export class InformationNawComponent {
  @Input() information: Information;

  constructor() {
    this.information = new Information();
  }

}
